import { StyledNewProductForm } from './style';
import { UploadFile } from 'antd/es/upload/interface';
import { CreateEditProductsGallery } from 'ui/UploadImage/product/CreateEditProductsGallery';

interface NewProductGalleryProps {
  onFileListChange?: (fileList: UploadFile[]) => void;
  fileList: UploadFile[];
  selectedImageName?: string;
  setSelectedImageName?: React.Dispatch<
    React.SetStateAction<string | undefined>
  >;
}

export const NewProductGallery = ({
  onFileListChange,
  fileList,
  selectedImageName,
  setSelectedImageName,
}: NewProductGalleryProps) => {
  return (
    <StyledNewProductForm>
      <div className={'image-upload'}>
        <CreateEditProductsGallery
          onFileListChange={onFileListChange}
          fileList={fileList}
          selectedImageName={selectedImageName}
          setSelectedImageName={setSelectedImageName}
        />
      </div>
    </StyledNewProductForm>
  );
};
